module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: ({
        callback: _vm.visibilityChanged,
        throttle: 300
      }),
      expression: "{\n  callback: visibilityChanged,\n  throttle: 300\n  }"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-cols footer-positive",
    class: _vm.isVisible ? 'enter' : ''
  }, [_c('div', {
    staticClass: "footer-left"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.footer_title'))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/arrow-footer-positive@2x.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_c('div', {
    staticClass: "footer-right-col"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.$t("message.footer_col_1_title_legal")))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm.$t("message.footer_col_1_address_legal"))), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "phone"
  }), _vm._v("+39 030 6871152 \n          "), _c('span', {
    staticClass: "fax"
  }), _vm._v("+39 030 6874933"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@myreplastindustries.it",
      "target": "_blank"
    }
  }, [_vm._v("info@myreplastindustries.it")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-right-col"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.footer_col_2'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-right-col"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/empty-col.png"),
      "alt": "Maire MyReplast"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.footer_col_5'))
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.footer_col_3'))
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.footer_col_4'))
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.$t('message.privacy_link')
    }
  }, [_c('span', {
    staticClass: "menu-item sub-item"
  }, [_vm._v(_vm._s(_vm.$t("message.footer_col_3_privacy_text")))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.$t('message.cookie_link')
    }
  }, [_c('span', {
    staticClass: "menu-item sub-item"
  }, [_vm._v(_vm._s(_vm.$t("message.footer_col_3_cookie_text")))])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.footer_col_whistleblowing'))
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          © 2023 Nextchem\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "legals--wrapper"
  }, [_vm._m(3), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.footer_legals_bottom'))
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-cols footer-negative"
  }, [_c('div', {
    staticClass: "footer-mask"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/footer-logo-maire.png"),
      "alt": "Maire MyReplast"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/footer-logo-next.png"),
      "alt": "Maire MyReplast"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "iubenda-cs-preferences-link",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "src": require("../../assets/images/iubenda-pref.svg"),
      "alt": "California Consumer Privacy Act (CCPA) Opt-Out Icon"
    }
  }), _vm._v(" Le tue preferenze relative alla privacy\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00765c4d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Footer.vue
// module id = 399
// module chunks = 0